import axios from '../../utils/axios';
import CRUD from './crud'

const tournamentJudgeProfiles = new CRUD('tournament-judge-profiles', 'superior-judge')

export default Object.assign(
    tournamentJudgeProfiles,
    {
        reducers: {
            ...tournamentJudgeProfiles.reducers
        },

    }
)
